// services/api.ts
import axios, { AxiosResponse, AxiosError } from 'axios';

// Set up interceptor to handle subscription errors
axios.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
        // Check for subscription required error (HTTP 402)
        if (error.response && error.response.status === 402) {
            // Save current location for redirect after subscription
            window.location.href = '/subscribe';
            // Return a resolved promise to prevent further error handling
            return Promise.resolve({ data: { redirected: true } });
        }

        return Promise.reject(error);
    }
);

export default axios;
